import { render, staticRenderFns } from "./AEstadoMoodle.vue?vue&type=template&id=3217b8ba"
import script from "./AEstadoMoodle.vue?vue&type=script&lang=js"
export * from "./AEstadoMoodle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports